import Navbar from '../Components/Navbar';
import Sidepanel from "../Savyn/Sidepanel";
import {
  Row,
} from "react-bootstrap";
import { useState } from "react";
import gqlQuery from "../GQL";
import { useMutation } from "@apollo/client";




const SelectMood = ({state, control, slide }) => {
  const [addJSON] = useMutation(gqlQuery.addJSON);
  const [startTime] = useState(new Date().toISOString());

  const addToSite = (answer)=>{
    return addJSON({
      variables: {
        json:JSON.stringify({
          answer,
          startTime,
          endTime:new Date().toISOString(),
          type: slide?.type,
          slide: slide?._slide,
        })
      }
    });
  }


  return (
    <>
 <Navbar state={state} control={control} slide={slide}/>

<Row className="bg-img min-vh-100" >
{/* <Container className="d-flex  justify-content-center vh-100 mh-100 "> */}
<Sidepanel state={state} control={control} slide={slide}/>
<div className="box text-left" >
          <h3 className="text-left my-4">How are you feeling now?</h3>

      <form className="">
  
      <button onClick={async()=>{
        await addToSite("Very bad")
        control.goSlide(slide.complete);
      }} type="button" className="btn btn-block text-center btn-lg mb-2 btnStandard">Very bad 😢</button>
    
      <button onClick={async()=>{
        await addToSite("Bad")
        control.goSlide(slide.complete)
      }} type="button" className="btn btn-block text-center btn-lg mb-2 btnStandard">Bad 🙁</button>
    
      <button onClick={async()=>{
        await addToSite("A little better")
        control.goSlide(slide.complete)
      }} type="button" className="btn btn-block text-center btn-lg mb-2 btnStandard">A little better 😑</button>
    
      <button onClick={async()=>{
        await addToSite("Better")
        control.goSlide(slide.complete)
      }} type="button" className="btn btn-block text-center btn-lg mb-2 btnStandard">Better 🙂</button>

      <button onClick={async()=>{
        await addToSite("Good")
        control.goSlide(slide.complete)
      }} type="button" className="btn btn-block text-center btn-lg mb-2 btnStandard">Good 😀</button>
   
      </form>
          </div>
          {/* </div> */}
          </Row>
    

    </>
  );
};
export default SelectMood;
